import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

const useAgentData = () => {
  const [agent, setAgent] = useState(null);
  const [dashboardSummary, setDashboardSummary] = useState(null);
  const [activeChats, setActiveChats] = useState([]);
  const [recentEmails, setRecentEmails] = useState([]);
  const [socialMentions, setSocialMentions] = useState([]);
  const [interactionHistory, setInteractionHistory] = useState([]);
  const [aiSuggestions, setAiSuggestions] = useState([]);
  const [customerInfo, setCustomerInfo] = useState(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAgentData = async () => {
      try {
        const docRef = doc(db, "dashboardData", "wO7MbHpTL2YUarVZfD56");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setAgent(data.agent);
          setDashboardSummary(data.dashboardSummary);
          setActiveChats(data.activeChats || []);
          setRecentEmails(data.recentEmails || []);
          setSocialMentions(data.socialMentions || []);
          setInteractionHistory(data.interactionHistory || []);
          setAiSuggestions(data.aiSuggestions || []);
          setCustomerInfo(data.customerInfo || null);
        } else {
          console.error("No such document!");
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAgentData();
  }, []);

  return {
    agent,
    dashboardSummary,
    activeChats,
    recentEmails,
    socialMentions,
    interactionHistory,
    aiSuggestions,
    customerInfo, // ✅ Return it
    loading,
  };
};

export default useAgentData;
